<template>
    <ValidationProvider :vid="vid" :rules="rules" v-slot="{ errors, valid }">
        <b-field
            :type="{ 'is-danger': errors[0] }"
            :message="errors"
            v-bind:class="{ 'is-success': valid }"
        >
            <div class="control has-icons-right">
                <input
                    :id="inputId"
                    :class="`input ${inputClasses}`"
                    v-model="innerValue"
                    autocomplete="on"
                    v-bind="$attrs"
                    :type="type"
                    :disabled="disabled"
                />
                <button class="revealButton" v-if="isPassword" @click="passwordRevealMethod">
                    <b-icon
                        pack="fas"
                        :icon="passwordReveal ? 'eye-slash' : 'eye'"
                        size="is-medium"
                        class="is-relative has-text-primary revealButton-icon"
                    ></b-icon>
                </button>
                <SafePasswordBar
                    id="safe-password-bar"
                    class="po-password-strength-bar"
                    v-if="safePassword && innerValue.length != 0"
                    :password="innerValue"
                ></SafePasswordBar>
            </div>
        </b-field>
    </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import SafePasswordBar from "@/components/inputs/SafePasswordBar";

export default {
    components: {
        ValidationProvider,
        SafePasswordBar,
    },
    props: {
        vid: {
            type: String,
        },
        rules: {
            type: [Object, String],
            default: "",
        },
        value: {
            type: null,
        },
        inputId: {
            type: String,
            default: null,
        },
        inputClasses: {
            type: String,
            default: "",
        },
        isPassword: {
            type: Boolean,
            default: false,
        },
        safePassword: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerValue: "",
            passwordReveal: false,
            type: "",
        };
    },
    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
        this.type = this.isPassword ? "password" : "text";
    },
    methods: {
        passwordRevealMethod() {
            this.passwordReveal = !this.passwordReveal;
        },
    },
    watch: {
        innerValue(newVal) {
            this.$emit("input", newVal);
        },
        value(newVal) {
            this.innerValue = newVal;
        },
        passwordReveal() {
            this.type = this.passwordReveal ? "text" : "password";
        },
    },
};
</script>
